function unhide(element) {
  $(element).find('.js-bookmark-icon').removeClass('dc-bookmark-icon--hidden')
}

function hide(element) {
  $(element).find('.js-bookmark-icon').addClass('dc-bookmark-icon--hidden')
}

function hoverState(element){
  element
  .on('mouseover', '.js-course-bookmarking', function(){
    unhide(this);
    })
  .on('mouseleave', '.js-course-bookmarking', function(){
      hide(this);
    });
}

hoverState($(".js-bookmarking-general"));
hoverState($(".js-bookmarking-courses"));
hoverState($(".js-bookmarking-new-courses"));
hoverState($(".js-bookmarking-bookmarks"));
hoverState($(".js-bookmarking-overview"));
hoverState($(".js-bookmarking-courses-overview"));
